import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { getUserEvents, UserEventListParams } from 'services/userEvent.service';

export const getUserEventsQueryKey = 'getUserEvents';

export const useUserEvents = (params?: UserEventListParams) => useQuery(
  [getUserEventsQueryKey, params],
  () => getUserEvents(params).then((r: AxiosResponse) => r.data),
  { refetchOnWindowFocus: false, retry: false },
);
